import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';

// Some product videos are in a format the browser can't read. The only way to
// find out is to load one and see. Most play, so the tile starts visible and
// comes away only for a broken file, rather than appearing after the first
// paint for every working one (CON-8753).
const useIsVideoPosterPlayable = src => {
  const $ = _c(3);
  const [isPlayable, setIsPlayable] = useState(true);
  let t0;
  let t1;
  if ($[0] !== src) {
    t0 = () => {
      setIsPlayable(true);
      if (!src) {
        return;
      }
      const video = document.createElement("video");
      const onError = () => setIsPlayable(false);
      video.addEventListener("error", onError);
      video.muted = true;
      video.preload = "metadata";
      video.src = src;
      return () => {
        video.removeEventListener("error", onError);
        video.removeAttribute("src");
        video.load();
      };
    };
    t1 = [src];
    $[0] = src;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return !!src && isPlayable;
};
export default useIsVideoPosterPlayable;